import { useQuery } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

import { useSnackbar } from 'notistack'
import { QueryParams } from '../../common/types'
import { getErrorMessage, parseQueryParams } from '../../utilities/parsers'
import apiUrl from '../../apis/api.url'
import {
  deleteData,
  getData,
  postData,
  updateData,
  updateFromData,
} from '../../apis/api.helpers'
import { useSnackbarManager } from '../../components/common/snackbar'

const buildUrlWithParams = (baseUrl: string, params: QueryParams) => {
  return `${baseUrl}${parseQueryParams(params)}`
}
const buildUrlParams = (baseUrl: string) => {
  return `${baseUrl}${parseQueryParams()}`
}

const tranningCalender = async () => {
  const response = await getData(apiUrl.TRAININGCALENDAR)
  return response
}

export const useTranningCalender = () => {
  return useQuery(['tranning-calender'], tranningCalender)
}

const customerMode = async (input: QueryParams) => {
  const url = buildUrlWithParams(apiUrl.CUSTOMER_MODE, {
    ...input,
  })
  const response = await getData(url)
  return response
}

export const useCustomerMode = (input: QueryParams) => {
  return useQuery(['customer_mode', input], () => customerMode(input), {})
}
export const deleteAdmin = (id?: string) => {
  return deleteData(`${apiUrl.ADMIN_INSTITUTIONS}/${id}`)
}

const adminDetails = async (id: string) => {
  const url = `${apiUrl.ADMIN_INSTITUTIONS}/${id}`
  const response = await getData(url)
  return response
}
export const useAdminDetails = (id: string) => {
  return useQuery(['worker_task', id], () => adminDetails(id), {
    refetchOnWindowFocus: false,
  })
}

export const createAdmin = (input: any) => {
  return postData(`${apiUrl.ADMIN_INSTITUTIONS}`, input)
}
export const useCreateAdmin = (handleSubmission: (data: any) => void) => {
  const { enqueueSnackbar } = useSnackbarManager()

  return useMutation(createAdmin, {
    onSuccess: (res: any) => {
      handleSubmission(res.data)
      enqueueSnackbar(
        'Customer Created Successfully. Please Assign Templates for the Customer',
        { variant: 'success' }
      )
    },

    onError: (error: any) => {
      enqueueSnackbar(getErrorMessage(error?.response?.data?.message), {
        variant: 'error',
      })
    },
  })
}

export const assignTemplate = (input: any) => {
  return postData(`${apiUrl.TEMPLATE_ASSIGN}`, input)
}
export const useAssignTemplate = (handleSubmission: (data: any) => void) => {
  const { enqueueSnackbar } = useSnackbarManager()
  return useMutation(assignTemplate, {
    onSuccess: (res: any) => {
      handleSubmission(res.data)
      enqueueSnackbar('Template Assigned Successfully', { variant: 'success' })
    },

    onError: (error: any) => {
      enqueueSnackbar(
        getErrorMessage(
          error.response.data.error || error?.response?.data?.detail
        ),
        {
          variant: 'error',
        }
      )
    },
  })
}

export const editCategory = (data: { id: number; input: any }) => {
  return updateData(`${apiUrl.ADMIN_INSTITUTIONS}/${data.id}`, {
    user: data.input,
  })
}

export const useUpdateAdmin = (
  handleSubmission: (data: any) => void // Simplify this if `id` isn't needed separately
) => {
  const { enqueueSnackbar } = useSnackbar()

  return useMutation(editCategory, {
    onSuccess: (res: any) => {
      handleSubmission(res.data)

      enqueueSnackbar('Customer Edited Successfully', { variant: 'success' })
    },
    onError: (error: any) => {
      enqueueSnackbar(getErrorMessage(error?.response?.data?.message), {
        variant: 'error',
      })
    },
  })
}

export const updatePassword = (employee: string, data: string) => {
  return updateFromData(
    `${apiUrl.ADMIN_USER}/${employee}/change_password`,
    data
  )
}

export const sendAdminInvitation = (id?: string) => {
  return postData(`${apiUrl.ADMIN_USER}/${id}/invite`, {})
}

const fetchEvents = async () => {
  const url = buildUrlParams(apiUrl.EVENT_LIST)
  const response = await getData(url)
  return response
}
export const useFetchEvents = () => {
  return useQuery(['members_listing'], () => fetchEvents(), {
    refetchOnWindowFocus: false,
  })
}
const fetchLearningForm = async (id: any) => {
  const url = `${apiUrl.LEARNING_FORM}/${id}/questions`

  const response = await getData(url)
  return response.data.questions || []
}

export const useFetchLearningForm = (id: any) => {
  return useQuery(['learning_form_detail', id], () => fetchLearningForm(id), {
    refetchOnWindowFocus: false,
    //staleTime: 50000,
  })
}
